import script from "./Collapse.vue?vue&type=script&setup=true&lang=js"
export * from "./Collapse.vue?vue&type=script&setup=true&lang=js"

import "./Collapse.vue?vue&type=style&index=0&id=09c8fc80&scoped=true&lang=scss"

import exportComponent from "/Users/ilvinipitter/code/lider-fornecedores/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09c8fc80"]])

export default __exports__